import {makeStyles} from '@mui/styles'

export default makeStyles(theme => ({
    tab: { 
        '& .MuiBox-root': {
          padding: '0px',
          },
        },
}));